
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { UserTeamModel } from './Identity.Api.Models.UserTeam';
import { Model, ModelProperty } from 'models/Model';


export class UserModel extends Model<UserModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'id', type: 'string', isHidden: true },
		{ name: 'adIdentifier', type: 'string' },
		{ name: 'username', type: 'string' },
		{ name: 'name', type: 'string' },
		{ name: 'email', type: 'string' },
		{ name: 'internalPhone', type: 'string' },
		{ name: 'created', type: 'Date', isHidden: true },
		{ name: 'deleted', type: 'Date', isHidden: true },
		{ name: 'secretKey', type: 'string' },
		{ name: 'defaultSalesTeamId', type: 'string' },
		{ name: 'admin', type: 'boolean' },
		{ name: 'userTeams', type: 'UserTeamModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new UserTeamModel }, properties: () => { return UserTeamModel.classProperties } },
		{ name: 'receiveNotificationsAsEmail', type: 'boolean' },
		{ name: 'settingsJson', type: 'string' },
		{ name: 'settings', type: 'UserSettingsModel', isHidden: true, isObject: true, new: () => { return new UserSettingsModel }, properties: () => { return UserSettingsModel.classProperties } }
	];
	[key: string]: any;
	
	public id?: string;
	public adIdentifier?: string;
	public username: string;
	public name: string;
	public email: string;
	public internalPhone: string;
	public created?: Date;
	public deleted?: Date;
	public secretKey: string;
	public defaultSalesTeamId?: string;
	public admin: boolean;
	public userTeams: UserTeamModel[];
	public receiveNotificationsAsEmail: boolean;
	public settingsJson?: string;
	public settings?: UserSettingsModel;
    
	constructor(){
		super();
		this.id = undefined;
		this.adIdentifier = undefined;
		this.username = '';
		this.name = '';
		this.email = '';
		this.internalPhone = '';
		this.created = undefined;
		this.deleted = undefined;
		this.secretKey = '';
		this.defaultSalesTeamId = undefined;
		this.admin = false;
		this.userTeams = [];
		this.receiveNotificationsAsEmail = false;
		this.settingsJson = undefined;
		this.settings = undefined;
		
	}
	getProperties(){
		return UserModel.classProperties;
	}
}
export class UserSettingsModel extends Model<UserSettingsModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'dashboardElementSettings', type: 'UserDashboardElementSettingModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new UserDashboardElementSettingModel }, properties: () => { return UserDashboardElementSettingModel.classProperties } }
	];
	[key: string]: any;
	
	public dashboardElementSettings: UserDashboardElementSettingModel[];
    
	constructor(){
		super();
		this.dashboardElementSettings = [];
		
	}
	getProperties(){
		return UserSettingsModel.classProperties;
	}
}
export class UserDashboardElementSettingModel extends Model<UserDashboardElementSettingModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'dashboardElementId', type: 'string' },
		{ name: 'isExcluded', type: 'boolean' },
		{ name: 'sortOrder', type: 'number' }
	];
	[key: string]: any;
	
	public dashboardElementId?: string;
	public isExcluded: boolean;
	public sortOrder?: number;
    
	constructor(){
		super();
		this.dashboardElementId = undefined;
		this.isExcluded = false;
		this.sortOrder = undefined;
		
	}
	getProperties(){
		return UserDashboardElementSettingModel.classProperties;
	}
}

